import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import Header from "./Header";
import { toWords } from "number-to-words";
import { useLocation, useNavigate } from "react-router-dom";

function UpdateProject() {
  const { state } = useLocation();
  const [id, setId] = useState(() => state?.id || "");
  const [ott, setOtt] = useState([]);
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  const [newProject, setNewProject] = useState({
    category: "",
    contentType: "",
    language: "",
    buyer: "",
    projectName: "",
    genre: "",
    synopsis: "",
    bannerName: "",
    productionHouse: "",
    producer: "",
    director: "",
    creativeDirector: "",
    writer: "",
    dop: "",
    trailer: "",
    trailerPassword: "",
    tentativeBudget: 0,
    ottId: "",
    story: "",
    casting: "",
    poster: "",
    contract: "",
    projectPPT: "",
    screenplay: "",
    budgetSheet: "",
  });

  // Handle input change for new project form
  const handleInputChange = useCallback((e) => {
    const { name, value } = e.target;
    setNewProject((prevProject) => ({
      ...prevProject,
      [name]: name === "tentativeBudget" ? parseFloat(value) || 0 : value,
    }));
  }, []);

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setNewProject((prevProject) => ({
      ...prevProject,
      [name]: files.length > 1 ? [...files] : files[0],
    }));
  };

  useEffect(() => {
    if (Array.isArray(projects) && projects.length > 0) {
      const firstProject = projects[0];
      if (firstProject.ottId && typeof firstProject.ottId === "object") {
        setNewProject((prev) => ({
          ...prev,
          ottId: firstProject.ottId._id,
        }));
      }
    }
  }, [projects]);

  // Fetch projects from the API when the component loads
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await axios.get(
          `http://fundoramaa.co.in//api/v1/projects/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          }
        );
        const project = response.data?.data;
        if (project && typeof project === "object") {
          setProjects([project]); // If you still want to keep this for some reason
          setNewProject((prev) => ({
            ...prev,
            ...project,
          }));
        } else {
          console.error("Unexpected response format:", response.data);
        }
      } catch (error) {
        console.error("Error fetching projects:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchProjects();
  }, [id]);

  // Handle adding a new project
  const handleUpdateProject = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("category", newProject.category);
    formData.append("contentType", newProject.contentType);
    formData.append("language", newProject.language);
    formData.append("buyer", newProject.buyer);
    formData.append("projectName", newProject.projectName);
    formData.append("genre", newProject.genre);
    formData.append("synopsis", newProject.synopsis);
    formData.append("story", newProject.story);
    formData.append("bannerName", newProject.bannerName);
    formData.append("productionHouse", newProject.productionHouse);
    formData.append("producer", newProject.producer);
    formData.append("director", newProject.director);
    formData.append("creativeDirector", newProject.creativeDirector);
    formData.append("writer", newProject.writer);
    formData.append("dop", newProject.dop);
    formData.append("casting", newProject.casting);
    formData.append("trailer", newProject.trailer);
    formData.append("trailerPassword", newProject.trailerPassword);
    formData.append("tentativeBudget", newProject.tentativeBudget);
    formData.append("ottId", newProject.ottId);

    // Optional file fields
    if (newProject.poster) {
      formData.append("poster", newProject.poster);
    }
    if (newProject.contract) {
      formData.append("contract", newProject.contract);
    }
    if (newProject.projectPPT) {
      formData.append("projectPPT", newProject.projectPPT);
    }
    if (newProject.screenplay) {
      formData.append("screenplay", newProject.screenplay);
    }
    if (newProject.budgetSheet) {
      formData.append("budgetSheet", newProject.budgetSheet);
    }

    try {
      const response = await axios.put(
        `http://fundoramaa.co.in//api/v1/projects/${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data?.data) {
        setProjects((prevProjects) =>
          prevProjects.map((proj) =>
            proj._id === id ? response.data.data : proj
          )
        );
        setIsSubmitting(false);
        navigate(-1);
      } else {
        console.error("Unexpected response format:", response.data);
        setIsSubmitting(false);
      }
    } catch (error) {
      console.error("Error updating project:", error);
      setIsSubmitting(false);
    }
  };

  // Fetch OTT from the API
  useEffect(() => {
    const fetchOtt = async () => {
      try {
        const response = await axios.get(
          "http://fundoramaa.co.in//api/v1/ott/"
        );
        if (response.data?.data && Array.isArray(response.data.data)) {
          setOtt(response.data.data);
        } else {
          console.error("Unexpected response format:", response.data);
        }
      } catch (error) {
        console.error("Error fetching otts:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchOtt();
  }, []);

  return (
    <>
      <div className="container">
        <div className="py-3">
          <div className="rounded-4">
            <div className="">
              <form onSubmit={handleUpdateProject}>
                <div className="py-2">
                  <div className="mb-3">
                    <span
                      onClick={() => window.history.back()}
                      class="back-button cursor-pointer"
                    >
                      <i className="bi bi-arrow-left h2"></i>
                    </span>
                    <div>
                      <h3 className="mb-0 lh-1">
                        <span className="text-reset">
                          {projects[0]?.projectName}
                        </span>
                      </h3>
                      <p className="m-0 text-capitalize">
                        {projects[0]?.category}
                      </p>
                      <span
                        class={`badge px-4 mt-2 ${
                          projects[0]?.ottUpdates === "approved"
                            ? "bg-success-soft"
                            : "bg-danger-soft"
                        } mb-2 text-capitalize`}
                      >
                        {projects[0]?.ottUpdates}
                      </span>
                    </div>
                  </div>

                  <div>
                    <div className="mb-3">
                      <p className="text-dark mb-1 bg-light py-2 text-center rounded-pill">
                        Category
                      </p>
                    </div>
                    <div>
                      <label>
                        Select category <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control mt-1"
                        name="category"
                        value={newProject.category}
                        onChange={handleInputChange}
                        required
                        autoComplete="off"
                      >
                        <option value="">Select</option>
                        <option value="new project">New Project</option>
                        <option value="gap funding">Gap Funding</option>
                      </select>
                    </div>
                  </div>
                  <div className="row g-3">
                    <div className="mt-5">
                      <p className="text-dark mb-1 bg-light py-2 text-center rounded-pill">
                        Content Type Selection
                      </p>
                    </div>
                    <div className="col-lg-6 col-12">
                      <label>
                        Select your type of content{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control mt-1"
                        name="contentType"
                        value={newProject.contentType}
                        onChange={handleInputChange}
                        required
                        autoComplete="off"
                      >
                        <option value="">Select</option>
                        <option value="tvshow">TV Show</option>
                        <option value="webseries">Web Series</option>
                        <option value="movie">Movie</option>
                        <option value="shortfilm">Short Film</option>
                      </select>
                    </div>
                    <div className="col-lg-6 col-12">
                      <label>
                        Select language <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control mt-1"
                        name="language"
                        value={newProject.language}
                        onChange={handleInputChange}
                        required
                        autoComplete="off"
                      >
                        <option value="">Select</option>
                        <option value="hindi">Hindi</option>
                        <option value="bengali">Bengali</option>
                        <option value="marathi">Marathi</option>
                        <option value="telugu">Telugu</option>
                        <option value="tamil">Tamil</option>
                        <option value="gujarati">Gujarati</option>
                        <option value="bhojpuri">Bhojpuri</option>
                        <option value="rajasthani">Rajasthani</option>
                        <option value="chhattisgarhi">Chhattisgarhi</option>
                        <option value="magahi">Magahi</option>
                        <option value="haryanvi">Haryanvi</option>
                        <option value="khortha/khotta">Khortha/Khotta</option>
                        <option value="marwari">Marwari</option>
                        <option value="bundeli/bundel khandi">
                          Bundeli/Bundel khandi
                        </option>
                        <option value="malvi">Malvi</option>
                        <option value="sadan/sadri">Sadan/Sadri</option>
                        <option value="mewari">Mewari</option>
                        <option value="awadhi">Awadhi</option>
                        <option value="lamani/lambadi">Lamani/Lambadi</option>
                        <option value="konkani">Konkani</option>
                        <option value="kurukh/oraon">Kurukh/Oraon</option>
                        <option value="tulu">Tulu</option>
                        <option value="manipuri">Manipuri</option>
                        <option value="sindhi">Sindhi</option>
                        <option value="pahari">Pahari</option>
                        <option value="hara/harauti">Hara/Harauti</option>
                        <option value="bagheli/baghel khandi">
                          Bagheli/Baghel Khandi
                        </option>
                        <option value="garhwali">Garhwali</option>
                        <option value="nimadi">Nimadi</option>
                        <option value="surjapuri">Surjapuri</option>
                        <option value="kumauni">Kumauni</option>
                        <option value="surgujia">Surgujia</option>
                        <option value="banjari">Banjari</option>
                        <option value="brajbhasha">Brajbhasha</option>
                        <option value="dhundhari">Dhundhari</option>
                        <option value="gojri/gujjari/gujar">
                          Gojri/Gujjari/Gujar
                        </option>
                        <option value="kangri">Kangri</option>
                        <option value="ahirani">Ahirani</option>
                        <option value="sambalpuri">Sambalpuri</option>
                        <option value="bagri">Bagri</option>
                        <option value="kachchhi">Kachchhi</option>
                      </select>
                    </div>
                  </div>
                  <div className="row g-3">
                    <div className="mt-6 mb-2">
                      <p className="text-dark mb-1 bg-light py-2 text-center rounded-pill">
                        Project Details
                      </p>
                    </div>
                    <div className="mt-2 col-lg-6 col-12">
                      <label>
                        Enter your rights buyer{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control mt-1"
                        placeholder=""
                        name="buyer"
                        value={newProject.buyer}
                        onChange={handleInputChange}
                        required
                        autoComplete="off"
                      />
                    </div>
                    <div className="mt-2 col-lg-6 col-12">
                      <label>
                        Enter your project name{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control mt-1"
                        placeholder=""
                        name="projectName"
                        value={newProject.projectName}
                        onChange={handleInputChange}
                        required
                        autoComplete="off"
                      />
                    </div>
                    <div className="col-lg-6 col-12">
                      <label>
                        Select Genre <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control mt-1"
                        name="genre"
                        value={newProject.genre}
                        onChange={handleInputChange}
                        required
                        autoComplete="off"
                      >
                        <option value="">Select</option>
                        <option value="Mystery Thriller">
                          Mystery Thriller
                        </option>
                        <option value="Historical Fiction">
                          Historical Fiction
                        </option>
                        <option value="Drama">Drama</option>
                        <option value="Mystery">Mystery</option>
                        <option value="Suspense">Suspense</option>
                        <option value="Action Adventures">
                          Action Adventures
                        </option>
                        <option value="Fantasy">Fantasy</option>
                        <option value="Romance">Romance</option>
                        <option value="Science Fiction">Science Fiction</option>
                        <option value="Relationship Fiction">
                          Relationship Fiction
                        </option>
                        <option value="Comedy">Comedy</option>
                        <option value="Love Story">Love Story</option>
                        <option value="Horror">Horror</option>
                        <option value="Crime">Crime</option>
                      </select>
                    </div>
                    <div className="mt-2 col-lg-6 col-12">
                      <label>
                        Upload Poster{" "}
                        <span className="text-danger">(JPG, JPEG, PNG)</span>{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="file"
                        name="poster"
                        onChange={handleFileChange}
                        className="form-control mt-1"
                        autoComplete="off"
                        accept=".jpg, .jpeg, .png"
                      />
                    </div>
                    <div className="mt-2 col-lg-6 col-12">
                      <label>
                        Upload Contract{" "}
                        <span className="text-danger">(PDF, DOCX)</span>{" "}
                      </label>
                      <input
                        type="file"
                        className="form-control mt-1"
                        placeholder=""
                        name="contract"
                        onChange={handleFileChange}
                        autoComplete="off"
                        accept=".pdf, .docx"
                      />
                    </div>
                  </div>
                  <div className="row g-3">
                    <div className="mt-6 mb-2">
                      <p className="text-dark mb-1 bg-light py-2 text-center rounded-pill">
                        Project Submission
                      </p>
                    </div>
                    <div className="mt-2">
                      <label>
                        Synopsis / One-Line Story{" "}
                        <span className="text-danger">(500 Words)</span>{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <textarea
                        type="text"
                        rows="5"
                        className="form-control mt-1"
                        name="synopsis"
                        value={newProject.synopsis}
                        onChange={handleInputChange}
                        autoComplete="off"
                      ></textarea>
                    </div>
                    <div className="mt-2 col-lg-6 col-12">
                      <label>
                        Banner Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control mt-1"
                        name="bannerName"
                        value={newProject.bannerName}
                        onChange={handleInputChange}
                        autoComplete="off"
                      />
                    </div>
                    <div className="mt-2 col-lg-6 col-12">
                      <label>
                        Production House Name{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control mt-1"
                        name="productionHouse"
                        value={newProject.productionHouse}
                        onChange={handleInputChange}
                        autoComplete="off"
                      />
                    </div>
                    <div className="mt-2 col-lg-6 col-12">
                      <label>
                        Producer / Investor{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control mt-1"
                        name="producer"
                        value={newProject.producer}
                        onChange={handleInputChange}
                        autoComplete="off"
                      />
                    </div>
                    <div className="mt-2 col-lg-6 col-12">
                      <label>
                        Director <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control mt-1"
                        name="director"
                        value={newProject.director}
                        onChange={handleInputChange}
                        autoComplete="off"
                      />
                    </div>
                    <div className="mt-2 col-lg-6 col-12">
                      <label>
                        Creative Director <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control mt-1"
                        name="creativeDirector"
                        value={newProject.creativeDirector}
                        onChange={handleInputChange}
                        autoComplete="off"
                      />
                    </div>
                    <div className="mt-2 col-lg-6 col-12">
                      <label>
                        Writer <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control mt-1"
                        name="writer"
                        value={newProject.writer}
                        onChange={handleInputChange}
                        autoComplete="off"
                      />
                    </div>
                    <div className="mt-2 col-lg-6 col-12">
                      <label>
                        Director of Photography (DOP){" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control mt-1"
                        name="dop"
                        value={newProject.dop}
                        onChange={handleInputChange}
                        autoComplete="off"
                      />
                    </div>
                    <div className="mt-2 col-lg-6 col-12">
                      <label>
                        Project & Cast PPT{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="file"
                        className="form-control mt-1"
                        name="projectPPT"
                        onChange={handleFileChange}
                        autoComplete="off"
                        accept=".pdf"
                      />
                    </div>
                    <div className="mt-2 col-lg-6 col-12">
                      <label>
                        Story Narration (Screenplay with Dialogue){" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="file"
                        className="form-control mt-1"
                        name="screenplay"
                        onChange={handleFileChange}
                        autoComplete="off"
                        accept=".pdf, .docx"
                      />
                    </div>
                    <div className="mt-2 col-lg-6 col-12">
                      <label>Trailer / Teaser (URL)</label>
                      <input
                        type="url"
                        className="form-control mt-1"
                        name="trailer"
                        value={newProject.trailer}
                        onChange={handleInputChange}
                        autoComplete="off"
                      />
                    </div>
                    <div className="mt-2 col-lg-6 col-12">
                      <label>Trailer / Teaser (Password)</label>
                      <input
                        type="password"
                        className="form-control mt-1"
                        name="trailerPassword"
                        value={newProject.trailerPassword}
                        onChange={handleInputChange}
                        autoComplete="off"
                      />
                    </div>
                    <div className="mt-2 col-lg-6 col-12">
                      <label>
                        Tentative Budget <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control mt-1"
                        name="tentativeBudget"
                        value={newProject.tentativeBudget}
                        onChange={handleInputChange}
                        required
                        autoComplete="off"
                        maxLength={10}
                      />
                      {newProject.tentativeBudget > 0 && (
                        <div>
                          <p className="text-capitalize mb-0 text-dark mt-2">
                            ({toWords(newProject.tentativeBudget)})
                          </p>
                        </div>
                      )}
                    </div>
                    <div className="mt-2 col-lg-6 col-12">
                      <label>
                        Budget Sheet{" "}
                        <span className="text-danger">(PDF, Excel)</span>{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="file"
                        className="form-control mt-1"
                        name="budgetSheet"
                        onChange={handleFileChange}
                        autoComplete="off"
                        accept=".pdf, .xls"
                      />
                    </div>
                    <div className="mt-2 col-lg-6 col-12">
                      <label>
                        Select OTT <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control mt-1"
                        name="ottId"
                        value={newProject.ottId}
                        onChange={handleInputChange}
                        required
                        autoComplete="off"
                      >
                        <option value="">Select</option>
                        {ott.map((platform) => (
                          <option key={platform._id} value={platform._id}>
                            {platform.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="row g-3">
                    <div className="col-6">
                      <button
                        type="submit"
                        className="btn btn-primary btn-lg mt-5 mb-2 w-100 rounded-3 fs-5 text-white"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? "Updating ..." : "Update"}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UpdateProject;
